<template>
  <div>

    <div class="item buttons">

      <button
          class="green"
          v-bind:class="{ 'glow': step > 5 }"
          @click.prevent.stop="start"
      >
        <span>{{ step > 5 ? 'SPIEL STARTEN' : 'WEITER' }}</span>
      </button>

      <!--      <button class="default nextButton"-->
      <!--              v-bind:class="{ 'hideme': step > 4 }"-->
      <!--              @click.prevent.stop="next"-->
      <!--      >-->
      <!--        Weiter-->
      <!--      </button>-->
    </div>

    <div class="item title">
      <h2 class="glitch">Steuerung</h2>
    </div>

    <img v-show="currentVideo === 'bike'"
         src="../assets/tutorial_BG_fahrrad2.jpg" alt=""/>

    <img v-show="currentVideo === 'car'"
         src="../assets/tutorial_BG_auto2.jpg" alt=""/>

    <div class="abdunkelung1"></div>
    <div class="abdunkelung2"></div>

    <div class="question-hot-indicator">
      <img alt="" src="../assets/button_situation.svg"/>
    </div>

    <div class="progression">
      <Progress
          ref="progressBar"
          @toggle-car="switchTo('car')"
          @toggle-bike="switchTo('bike')"
          :perspectiveStart="'car'"
          @toggle-full="toggleFull"
      />
    </div>

    <transition name="fade">
      <div class="item tt1 tt" v-if="step > 0">
        <svg viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(0, -10)" d="M0 10 L20 10 L0 0 L0 10"/>
          </g>
        </svg>
        <span class="ttDesktop">
          Klicken Sie jederzeit hier, um das Spiel zu verlassen.
        </span>
        <span class="ttMobile">
          Klicken Sie jederzeit hier, um das Spiel zu verlassen.
        </span>

        <!--      <br />-->
        <!--      <br />-->
        <!--      <a style="float:right; color: white; text-decoration: none;" href="#">-->
        <!--        Weiter &gt;-->
        <!--      </a>-->
      </div>
    </transition>

    <!-- unten links -->
    <transition name="fade">
      <div class="item tt2 tt" v-if="step > 1">
        <svg viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(0, 10)" d="M0 0 L20 0 L0 10 L0 0"/>
          </g>
        </svg>
        <span class="ttDesktop">
          Drücken Sie die Steuerungs- bzw. die Control-Taste für den
          Perspektivwechsel zwischen Auto und Fahrrad.
          Probieren Sie es gleich aus!
        </span>
        <span class="ttMobile">
          Klicken Sie auf die Icons, um die Perspektiven
          zwischen Auto und Fahrrad zu wechseln.
        </span>
      </div>
    </transition>

    <!-- unten mitte -->
    <transition name="fade">
      <div class="item tt3 tt" v-if="step > 2">
        <svg class="noep1" viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(-10, 10)" d="M0 0 L10 10 L20 0 L0 0"/>
          </g>
        </svg>
        <svg class="noep2" viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(20, 0)"
                  d="M0 0 L10 10 L0 20 L0 0"/>
          </g>
        </svg>
        <span class="ttDesktop">
          Drücken Sie die Alt- bzw. die Option-Taste,
          wenn Sie eine Gefahrensituation entdecken.
          Achten Sie dafür auf das Ausrufezeichen.
          Haben Sie einen Fehler entdeckt,
          können Sie sich den Abschnitt erneut ansehen.
        </span>
        <span class="ttMobile">
          Haben Sie einen Fehler entdeckt? Dann klicken Sie
          auf das Ausrufezeichen, sobald es erscheint.
        </span>
      </div>
    </transition>

    <!-- oben rechts -->
    <transition name="fade">
      <div class="item tt4 tt" v-if="step > 4">
        <svg viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(0, -10)" d="M0 10 L20 10 L20 0 L0 10"/>
          </g>
        </svg>
        <span class="ttDesktop">
          Hier sehen Sie, wie viele Fehler Sie schon entdeckt haben.
        </span>
        <span class="ttMobile">
          Hier sehen Sie, wie viele Fehler Sie schon entdeckt haben.
        </span>
      </div>
    </transition>

    <!-- unten rechts -->
    <transition name="fade">
      <div class="item tt5 tt" v-if="step > 3">
        <svg viewBox="0 0 20 10" overflow="visible">
          <g fill="#262626">
            <path transform="translate(0, 10)" d="M0 0 L20 0 L20 10 L0 0"/>
          </g>
        </svg>
        <span class="ttDesktop">
          Klicken Sie hier oder drücken Sie
          die Leertaste für eine Pause.
        </span>
        <span class="ttMobile">
          Um das Spiel zu pausieren oder weiterzuspielen,
          klicken Sie auf diesen Button.
        </span>
      </div>
    </transition>

    <div class="skipTut">
      <a
          href="#"
          @click.prevent.stop="skip"
      >
        Tutorial überspringen
        <img
            src="../assets/icons_UI_chevron_right.svg"
            alt="" />
      </a>
    </div>

  </div>
</template>

<script>

import Perspectives from "../Perspectives";
import Progress from "./Progress";

export default {
  name: "TutorialContainer",
  components: {Progress},
  props: {},
  data() {
    return {
      currentVideo: Perspectives.car,
      duration: 150,
      step: 0,
      show: true,
      interval: null,
    }
  },
  created() {
    window.addEventListener('keydown', this.mapControls);
  },
  destroyed() {
    window.removeEventListener('keydown', this.mapControls);
  },
  mounted() {

    this.$refs.progressBar.tick(
        96,
        Perspectives.car,
        150
    );
    this.$refs.progressBar.question(
        true,
        false,
    );

    setTimeout(
        () => {
          this.next();
          //       this.interval = setInterval(() => {
          //         this.next();
          //       }, 2000);
        },
        500
    );


  },
  methods: {

    start() {
      if (this.step === 6) {
        this.$router.push({name: 'Perspective', params: {perspective: this.currentVideo}})
      } else {
        this.next();
      }
    },

    skip() {
      this.step = 6;
    },

    next() {
      this.step++;
      // if (this.step > 5) {
      //   clearInterval(this.interval);
      // }
    },

    mapControls(e) {

      e.preventDefault();

      const keyUp = () => {

        e.preventDefault();

        if (e.key === 'Control') {
          this.togglePerspective();
        }

        window.removeEventListener('keyup', keyUp);
        window.addEventListener('keydown', this.mapControls);
      }

      window.addEventListener('keyup', keyUp);
      window.removeEventListener('keydown', this.mapControls);
    },
    switchTo(perspective) {
      if (perspective !== this.currentVideo) this.togglePerspective();
    },
    toggleFull(e) {
      if (window.appIsFullScreen) {
        if (document.documentElement.requestFullscreen) {
          document.exitFullscreen();
        }
        else if (document.documentElement.webkitRequestFullscreen) {
          document.webkitExitFullscreen();
        }
        window.appIsFullScreen = false;
        this.$refs.progressBar.full(false);
      } else {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen();
        }
        window.appIsFullScreen = true;
        this.$refs.progressBar.full(true);
      }
    },
    togglePerspective() {
      let otherPerspective = this.currentVideo === Perspectives.car
          ? Perspectives.bike
          : Perspectives.car
      ;
      this.$refs.progressBar.switch(
          156,
          otherPerspective,
          250
      );
      this.$refs.progressBar.tutorial();
      this.$refs.progressBar.question(
          true,
          false
      );
      this.currentVideo = otherPerspective;
    },
  },
  computed: {}
}
</script>

<style lang="scss" scoped>


$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to,
.fade-leave-active {
  opacity: 0;
}

.hideme {
  transition: visibility .5s, opacity .5s;
  opacity: 0;
  visibility: hidden;
}


.question-hot-indicator {
  position: absolute;
  display: none;
}

.mobile .question-hot-indicator {
  display: block;
}

.item {
  position: absolute;
}

.tt {
  background-color: #262626;
  color: #ffffff;
  text-align: center;
}

.mobile .tt {
  text-align: left;
}

.tt svg {
  position: absolute;
}

.tt1 svg {
  top: 0;
  left: 0;
}

.tt2 svg {
  bottom: 0;
  left: 0;
}

.tt3 svg {
  bottom: 0;
  left: 50%;
}

.tt4 svg {
  top: 0;
  right: 0;
}

.tt5 svg {
  bottom: 0;
  right: 0;
}

.buttons {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title {
  width: 100%;
  display: flex;
  justify-content: center;
}

.progression {
  position: absolute;
  bottom: 2%;
  width: 100%;
}

img {
  width: 100%;
  height: 100%;
}

.ttMobile {
  display: none;
}

.noep2 {
  display: none;
}

.skipTut {

  position: absolute;
  top: 50%;

  a {
    color: #FFF;
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }

  img {
    width: auto;
  }
}

.mobile {
  .skipTut {
    top: 70%;
    right: 0;
    left: 0;
    width: 100%;
    text-align: center;
    a {
      justify-content: center;
    }
  }
  .ttMobile {
    display: inline;
  }
  .ttDesktop {
    display: none;
  }
  .tt3 {
    left: auto;
  }
  .noep1 {
    display: none;
  }
  .noep2 {
    display: block;
  }
  .tt3 svg.noep2 {
    bottom: 30%;
    right: 0;
    left: auto;
  }
}

@media(min-aspect-ratio: 16/9) {

  .skipTut {
    white-space: nowrap;
    right: scaleVh(50);
    font-size: scaleVh(16);
    img {
      height: scaleVh(14);
      margin-left: scaleVh(12);
      margin-bottom: scaleVh(4);
    }
  }

  .nextButton {
    margin-top: scaleVh(20);
  }

  .tt {
    padding: scaleVh(20);
    font-size: scaleVh(16);
    line-height: scaleVh(22);
    width: scaleVh(268);
  }

  .tt svg {
    width: scaleVh(20);
    height: scaleVh(10);
  }

  .tt1 {
    left: scaleVh(55);
    top: scaleVh(100);
  }
  .tt4 {
    top: scaleVh(80);
    right: scaleVh(100);
  }

  .tt2 {
    left: scaleVh(55);
    bottom: scaleVh(190);
  }
  .tt3 {
    left: 54%;
    bottom: scaleVh(160);
  }
  .tt5 {
    right: scaleVh(60);
    bottom: scaleVh(185);
  }

  // mobile -------------
  .mobile {
    .skipTut {
      font-size: scaleMobileVh(12);
      img {
        height: scaleMobileVh(10);
        margin-left: scaleMobileVh(8);
        margin-bottom: scaleMobileVh(4);
      }
    }
    .question-hot-indicator {
      right: scaleMobileVh(26);
      top: scaleMobileVh(173);
      img {
        width: scaleMobileVh(30);
        height: scaleMobileVh(30);
      }
    }
    .tt {
      padding: scaleMobileVh(8);
      font-size: scaleMobileVh(12);
      line-height: scaleMobileVh(16);
      width: scaleMobileVh(200);
    }
    .tt svg {
      width: scaleMobileVh(20);
      height: scaleMobileVh(10);
    }
    .tt1 {
      width: scaleMobileVh(170);
      left: scaleMobileVh(25);
      top: scaleMobileVh(55);
    }
    .tt4 {
      width: scaleMobileVh(170);
      top: scaleMobileVh(50);
      right: scaleMobileVh(35);
    }
    .tt2 {
      width: scaleMobileVh(170);
      left: scaleMobileVh(35);
      bottom: scaleMobileVh(105);
    }
    .tt3 {
      width: scaleMobileVh(180);
      right: scaleMobileVh(73);
      bottom: scaleMobileVh(165);
    }
    .tt5 {
      width: scaleMobileVh(200);
      right: scaleMobileVh(25);
      bottom: scaleMobileVh(85);
    }
    button {
      padding: 0 scaleMobileVh(10);
    }
  }

}

@media(max-aspect-ratio: 16/9) {

  .skipTut {
    white-space: nowrap;
    right: scaleVw(50);
    font-size: scaleVw(16);
    img {
      height: scaleVw(14);
      margin-left: scaleVw(12);
      margin-bottom: scaleVw(4);
    }
  }

  .nextButton {
    margin-top: scaleVw(20);
  }

  .tt {
    padding: scaleVw(20);
    font-size: scaleVw(16);
    line-height: scaleVw(22);
    width: scaleVw(268);
  }

  .tt svg {
    width: scaleVh(20);
    height: scaleVh(10);
  }

  .tt1 {
    left: scaleVw(55);
    top: scaleVw(100);
  }
  .tt4 {
    top: scaleVw(80);
    right: scaleVw(100);
  }

  .tt2 {
    left: scaleVw(55);
    bottom: scaleVw(190);
  }
  .tt3 {
    left: 54%;
    bottom: scaleVw(160);
  }
  .tt5 {
    right: scaleVw(60);
    bottom: scaleVw(185);
  }

  .mobile {
    .skipTut {
      font-size: scaleMobileVw(12);
      img {
        height: scaleMobileVw(10);
        margin-left: scaleMobileVw(8);
        margin-bottom: scaleMobileVw(4);
      }
    }
    .question-hot-indicator {
      right: scaleMobileVw(26);
      top: scaleMobileVw(173);
      img {
        width: scaleMobileVw(30);
        height: scaleMobileVw(30);
      }
    }
    .tt {
      padding: scaleMobileVw(8);
      font-size: scaleMobileVw(12);
      line-height: scaleMobileVw(16);
      width: scaleMobileVw(200);
    }
    .tt svg {
      width: scaleMobileVw(20);
      height: scaleMobileVw(10);
    }
    .tt1 {
      width: scaleMobileVw(170);
      left: scaleMobileVw(25);
      top: scaleMobileVw(55);
    }
    .tt4 {
      width: scaleMobileVw(170);
      top: scaleMobileVw(50);
      right: scaleMobileVw(35);
    }
    .tt2 {
      width: scaleMobileVw(170);
      left: scaleMobileVw(35);
      bottom: scaleMobileVw(105);
    }
    .tt3 {
      width: scaleMobileVw(180);
      right: scaleMobileVw(73);
      bottom: scaleMobileVw(165);
    }
    .tt5 {
      width: scaleMobileVw(200);
      right: scaleMobileVw(25);
      bottom: scaleMobileVw(85);
    }
    button {
      padding: 0 scaleMobileVw(10);
    }
  }
}


</style>